import type {
	CookieConsentCombinedType,
	CookieConsentObjectType,
} from '#base/core/types/CookieConsentType';
import { getConsentObject, getConsentSetCookieKey } from '#base/helpers/cookieHelpers';
import { getDateIn1Year } from '#base/helpers/dateHelpers';

const allConsents: CookieConsentObjectType = getConsentObject();

const cookieSettings = ref<CookieConsentObjectType>(allConsents);

export default () => {
	const {
		isCookieDialogOpen, closeDialog, openCookieDialog,
	} = useDialogs();
	const {
		updateConsent,
	} = useEventTracking();

	const cookieConsentSetKey = getConsentSetCookieKey();
	const dateIn1Year = getDateIn1Year();
	const cookieConsentSet = useCookie<boolean>(cookieConsentSetKey, {
		expires: dateIn1Year,
	});
	const cookieConsent = useCookie<CookieConsentObjectType>('consent', {
		expires: dateIn1Year,
	});

	const setConsentSettings = (consent: CookieConsentObjectType) => {
		cookieSettings.value = consent;
	};

	/**
     * Push consents to gtag.
     */
	const pushConsents = (consentObject: {
		[Property in keyof Gtag.ConsentParams]: 'on' | 'off';
	}) => {
		const consents: {
			[key: string]: 'granted' | 'denied';
		} = {};

		Object.entries(consentObject).forEach(([key, value]) => {
			consents[key] = value === 'on' ? 'granted' : 'denied';
		});

		updateConsent(consents);
	};

	const submitConsentSettings = () => {
		pushConsents(cookieSettings.value);
		cookieConsent.value = cookieSettings.value;
		cookieConsentSet.value = true;
		closeDialog();
	};

	const hasConsentFor = (consentType: CookieConsentCombinedType) =>
		cookieConsent.value?.[consentType] === 'on';

	onMounted(() => {
		if (!cookieConsentSet.value) {
			openCookieDialog();
		}
		else {
			pushConsents(cookieConsent.value);
			setConsentSettings(cookieConsent.value);
		}
	});

	return {
		setConsentSettings,
		cookieSettings,
		isConsentGiven: cookieConsentSet.value,
		submitConsentSettings,
		hasConsentFor,
		isCookieDialogOpen,
	};
};
